import request from '@/utils/request'
export function get(e) {
    return request({
        url: '/weixin/share?url='+encodeURIComponent(e),
        method: 'get',

    })
}
export function status(e) {
    return request({
        url: '/weixin/status',
        method: 'get',

    })
}


// WEBPACK FOOTER //
// ./src/api/weixin.js